<div class="custom-alert-container" *ngIf="!isLoadingLabels">
	<div class="header-wrap">
		<span class="tab selected">{{ labels.lbl_alertas_personalizados }}</span>
	</div>

	<div class="body-wrap">
		<ng-container *ngIf="!isLoadingCustomAlert && !isLoadingNewCiType">
			<div class="register-container" *ngIf="selectedTab === 'register'">
				<span class="search-title">{{ labels.lbl_geral_inclusao }}</span>
				<div hidden class="dotted-input-container">
					<span>{{ labels.lbl_geral_cliente }}</span>
					<select (change)="selectedCustomAlert.customer = $event.target.value">
						<option [selected]="selectedCustomAlert.customer === ''">{{ labels.lbl_geral_selecione }}</option>
						<option
							[selected]="selectedCustomAlert.customer.toString() === customer.id.toString()"
							[value]="customer.id"
							*ngFor="let customer of customerArray">
							{{ customer.name }}
						</option>
					</select>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_tipo_ativo }}</span>
					<select (change)="selectedCustomAlert.asset_type = $event.target.value">
						<option [selected]="selectedCustomAlert.asset_type === ''">{{ labels.lbl_geral_selecione }}</option>
						<option
							[selected]="selectedCustomAlert.asset_type === ciType.type"
							[value]="ciType.type"
							*ngFor="let ciType of newCiTypesArray">
							{{ labels[ciType.label] ? labels[ciType.label] : ciType.type }}
						</option>
					</select>
				</div>

				<div class="mb-1" *ngIf="selectedCustomAlert.asset_type === 'servers' || selectedCustomAlert.asset_type === 'workstations'">
					<span class="tip">_Receba uma notificação em seu email ao ser criado um novo equipamento.</span>
				</div>

				<div class="mb-1" *ngIf="selectedCustomAlert.asset_type === 'consumable'">
					<span>{{ labels.lbl_geral_moficado }}:</span>
					<div class="mb-1">
						<div class="dottend-input-container" *ngFor="let checkbox of AlertItemsConsumable">
							<cpi-checkbox [value]="checkbox.isChecked" [innerText]="checkbox.name" (oValue)="checkbox.isChecked = $event">
								<input
									type="text"
									[value]="selectedCustomAlert.lending_expires_days"
									(input)="selectedCustomAlert.lending_expires = $event.target.value"
									[placeholder]="labels.lbl_dia_para_expirar" />
							</cpi-checkbox>
						</div>
					</div>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_email_copia }}</span>
					<input type="text" [value]="selectedCustomAlert.email" (input)="selectedCustomAlert.email = $event.target.value" />
				</div>

				<div class="button-container">
					<div class="button" (click)="clearForm()">{{ labels.lbl_geral_limpar_campos }}</div>
					<div class="button" (click)="createNotification()" *ngIf="selectedCustomAlert.id === ''">
						<span>{{ labels.lbl_geral_criar_notificacoes }}</span>
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isCreatingNotification"></cpi-dot-bounce-loading-effect>
					</div>
					<div class="button" (click)="updateNotification()" *ngIf="selectedCustomAlert.id !== ''">
						<span>{{ labels.lbl_geral_atualizar }}</span>
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isCreatingNotification"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</div>

			<div class="search-container" *ngIf="selectedTab === 'search'">
				<span class="search-title">{{ labels.lbl_geral_pesquisa }}</span>

				<div hidden class="dotted-input-container">
					<span>{{ labels.lbl_geral_cliente }}</span>
					<select (change)="selectedCustomAlert.customer = $event.target.value">
						<option [selected]="selectedCustomAlert.customer === ''">{{ labels.lbl_geral_selecione }}</option>
						<option [value]="customer.id" *ngFor="let customer of customerArray">{{ customer.name }}</option>
					</select>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_tipo_ativo }}</span>
					<select (change)="this.selectedCustomAlert.asset_type = $event.target.value">
						<option [selected]="selectedCustomAlert.customer === ''">{{ labels.lbl_geral_selecione }}</option>
						<option [value]="ciType.type" *ngFor="let ciType of newCiTypesArray">
							{{ labels[ciType.label] ? labels[ciType.label] : ciType.type }}
						</option>
					</select>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_email_copia }}</span>
					<input type="text" [value]="selectedCustomAlert.email" (input)="selectedCustomAlert.email = $event.target.value" />
				</div>

				<div class="button-container">
					<div class="button" (click)="clearForm()">{{ labels.lbl_geral_limpar_campos }}</div>
					<div class="button" (click)="searchNotification()">
						<span>{{ labels.lbl_geral_pesquisar_notificacoes }}</span>
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isSearchingNotifications"></cpi-dot-bounce-loading-effect>
					</div>
				</div>

				<br />

				<div *ngFor="let customAlert of searchCustomAlerts; let index = index">
					<div>
						<div class="customAlertCard">
							<div hidden class="dotted-input-container">
								<span>{{ labels.lbl_geral_cliente }}</span>
								<span>{{ customAlert.customer }}</span>
							</div>
							<div class="dotted-input-container">
								<span>{{ labels.lbl_geral_email_copia }}</span>
								<input disabled [value]="customAlert.email" />
							</div>
							<div class="custom-alert-asset-type-list">
								<span>{{ labels.lbl_geral_tipo_ativo }}</span>
								<span *ngIf="customAlert.asset_type === 'workstations'">{{ labels.lbl_asset_micro }}</span>
								<span *ngIf="customAlert.asset_type === 'servers'">{{ labels.lbl_asset_servidor }}</span>
								<span *ngIf="customAlert.asset_type === 'maintenance_contracts'">{{ labels.lbl_geral_contratos }}</span>
								<span *ngIf="customAlert.asset_type === 'TMBP'">{{ labels.lbl_geral_tmbp }}</span>
								<span *ngIf="customAlert.asset_type === 'consumable'">{{ labels.lbl_consumable }}</span>
								<span *ngIf="customAlert.asset_type === 'consumable'">_Alerta de Devolução de Estoque</span>
							</div>

							<div class="button-container">
								<div class="button" (click)="editNotification(customAlert.id)">Editar</div>
								<div
									class="button"
									[ngClass]="{ beforeToConfirm: 'isSearchingNotifications' }"
									(click)="confirmDeactiveClick($event, index)"
									#confirmDeactiveButton>
									{{
										confirmDeactiveButton.classList.contains('double-click')
											? labels.lbl_geral_confirmar
											: labels.lbl_geral_excluir
									}}
								</div>
								<span
									(click)="
										confirmDeleteFile.classList.contains('confirmClick')
											? deleteNotification(index)
											: confirmButton(confirmDeleteFile, index)
									"
									#confirmDeleteFile></span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="button-search-container">
				<div class="button" (click)="selectedTab = 'register'; clearForm()" *ngIf="selectedTab === 'search'">
					{{ labels.lbl_nova_notificacao }}
				</div>
				<div class="button" (click)="clearForm()" (click)="selectedTab = 'search'" *ngIf="selectedTab === 'register'">
					<div (click)="clearForm()">{{ labels.lbl_geral_voltar }}</div>
				</div>
			</div>
		</ng-container>

		<cpi-dot-bounce-loading-effect
			[color]="'var(--primary-color-1)'"
			*ngIf="isLoadingCustomAlert || isLoadingNewCiType"></cpi-dot-bounce-loading-effect>
	</div>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingLabels" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>

<!--isLoadingCustomer ||-->
